import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper functions for authentication
export const authHelpers = {
  // Sign up
  signUp: async ({ email, password, firstName, lastName, title, phone }) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          first_name: firstName,
          last_name: lastName,
          title,
          phone
        }
      }
    });
    return { data, error };
  },

  // Sign in
  signIn: async ({ email, password }) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    return { data, error };
  },

  // Sign out
  signOut: async () => {
    const { error } = await supabase.auth.signOut();
    return { error };
  },

  // Get current user
  getUser: async () => {
    const {
      data: { user },
      error
    } = await supabase.auth.getUser();
    return { user, error };
  },

  // Get session
  getSession: async () => {
    const {
      data: { session },
      error
    } = await supabase.auth.getSession();
    return { session, error };
  },

  // Reset password request
  resetPassword: async email => {
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    });
    return { data, error };
  },

  // Update password
  updatePassword: async newPassword => {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword
    });
    return { data, error };
  },

  // Verify current user's password
  verifyPassword: async (email, password) => {
    try {
      // Attempt to sign in with the provided credentials
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) {
        return { verified: false, error };
      }

      return { verified: true, error: null };
    } catch (error) {
      return { verified: false, error };
    }
  },

  // Change password (verifies current password first)
  changePassword: async (email, currentPassword, newPassword) => {
    try {
      // First verify the current password
      const { verified, error: verifyError } = await authHelpers.verifyPassword(
        email,
        currentPassword
      );

      if (!verified || verifyError) {
        return {
          success: false,
          error: verifyError || { message: 'Current password is incorrect' }
        };
      }

      // Update to new password
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (error) {
        return { success: false, error };
      }

      return { success: true, error: null };
    } catch (error) {
      return { success: false, error };
    }
  }
};
